$(function () {
    'use strict';

    activate();

    ////////////////////

    function activate() {
        $(document)
            .on('stickyNav:on', onStickyBegin)
            .on('stickyNav:off', onStickyStop);

        $(window)
            .on('resize', onWindowResize);

        syncPosition();
    }

    function onStickyBegin() {
        $('.share-bar--sticky').addClass('sticky');
        syncPosition();
    }

    function onStickyStop() {
        $('.share-bar--sticky').removeClass('sticky');
        syncPosition();
    }

    function onWindowResize() {
        syncPosition();
    }

    function syncPosition() {
        var $shareBar = $('.share-bar--sticky');
        var $pageContent = $('.page__content');
        var isSticky = $shareBar.hasClass('sticky');

        $shareBar.show();

        if ($pageContent.length) {
            if (isSticky) {
                var left = Math.floor($pageContent.offset().left - $shareBar.outerWidth(true));
                $shareBar.css('left', left + 'px');
            } else {
                $shareBar.css('left', '');
            }
        }
    }
});
